'use strict'

import {init as pdfjsInit,getPdfJs} from './pdfmain';
export function init(pdflink){
    pdfjsInit();
    const pdfjs=getPdfJs();
    const arrayImage=[];

    pdfjs.getDocument(pdflink).promise.then(pdf=>{
        let maindiv=document.createElement('div');
        let pages=pdf.numPages;
        if(pages > 1 ){
            for(let i=1; i <=pages;i++){
                pdf.getPage(i).then(page =>{
                    const devicePixelRatio=window.devicePixelRatio || 1;
                    const viewport=page.getViewport({scale:1})
                    const canvas=document.createElement('canvas');
                    // canvas.width=viewport.width;
                    // canvas.height=viewport.height;
                    canvas.width = viewport.width * devicePixelRatio;
                    canvas.height = viewport.height * devicePixelRatio;
                    canvas.style.width = viewport.width;
                    canvas.style.height = viewport.height;

                    const transform = [ devicePixelRatio, 0 , 0, devicePixelRatio, 0, 0];

                    const context=canvas.getContext("2d")
                    const renderContext = {
                      canvasContext: context,
                      viewport,
                      transform: transform
                    }
                    page.render(renderContext).promise.then(()=>{
                        const url=canvas.toDataURL()
                        arrayImage.push(url);
                    })
                    maindiv.append(canvas)
                } );
            }
        }
    })
    return arrayImage;
}

// pdfjs.getDocument(pdflink).promise
//     .then(pdf=>{
//         warm_cache_1(pdf,1)
//     })
//
// function warm_cache_1(pdf, n) {
//     if(n <= pdf.numPages) get_page_1(pdf, n, () => warm_cache_1(pdf, n+1))
// }
// function get_page_1(pdf, n, cb) {
//     if(!n || n > pdf.numPages) return cb()
//     if(cache[n]) return cb(null, cache[n])
//
//     pdf.getPage(n)
//         .then(page => {
//             const viewport = page.getViewport({scale:1.5})
//             const canvas = h("canvas")
//             canvas.width = viewport.width
//             canvas.height = viewport.height
//
//             const context = canvas.getContext("2d")
//             const renderContext = {
//                 canvasContext: context,
//                 viewport,
//             }
//             page.render(renderContext).promise
//                 .then(() => {
//                     const img = new Image()
//                     img.src = canvas.toDataURL()
//                     console.log(canvas.toDataURL())
//                     img.addEventListener("load", () => {
//                         arrayImage.push(cache[n]);
//                         cache[n] = {
//                             img,
//                             num: n,
//                             width: img.width,
//                             height: img.height,
//                         }
//                         cb(null, cache[n])
//                     }, false)
//
//                 })
//                 .catch(err => cb(err))
//         })
//         .catch(err => cb(err))
//
// }
// return arrayImage;